import * as types from '../types';
import { ISurveysApi } from '../contracts';
import { HttpApi } from './HttpApi';

const enc = encodeURIComponent;

/** Only the filters that are set go on the query string (the server rejects blanks). */
function params(query: Record<string, string | number | boolean | undefined>): Record<string, string | number> {
  const result: Record<string, string | number> = {};
  Object.entries(query).forEach(([key, value]) => {
    if (value === undefined || value === '' || value === false) return;
    result[key] = value === true ? 'true' : value;
  });
  return result;
}

/** Customer satisfaction surveys (tracker item 69). */
export class SurveysHttpApi extends HttpApi implements ISurveysApi {
  async getSurveySettings(): Promise<types.SurveySettings> {
    return (await this.http.get<types.APIResponse<types.SurveySettings>>('/surveys/settings')).data.data;
  }

  async updateSurveySettings(input: types.UpdateSurveySettingsInput): Promise<types.SurveySettings> {
    return (await this.http.put<types.APIResponse<types.SurveySettings>>('/surveys/settings', input)).data.data;
  }

  async listSurveyResponses(query: types.SurveyListQuery = {}): Promise<types.SurveyListResponse> {
    return (await this.http.get<types.APIResponse<types.SurveyListResponse>>('/surveys', { params: params({ ...query }) })).data.data;
  }

  async getJobSurvey(jobId: string): Promise<types.JobSurvey> {
    return (await this.http.get<types.APIResponse<types.JobSurvey>>(`/jobs/${enc(jobId)}/survey`)).data.data;
  }

  async sendJobSurvey(jobId: string, idempotencyKey?: string): Promise<types.SendSurveyResult> {
    return (await this.http.post<types.APIResponse<types.SendSurveyResult>>(`/jobs/${enc(jobId)}/survey/send`, idempotencyKey ? { idempotencyKey } : {})).data.data;
  }

  async getSatisfactionReport(query: types.SatisfactionReportQuery = {}): Promise<types.SatisfactionReport> {
    return (await this.http.get<types.APIResponse<types.SatisfactionReport>>('/reports/customer-satisfaction', { params: params({ ...query }) })).data.data;
  }

  async getPublicSurvey(token: string): Promise<types.PublicSurvey> {
    return (await this.http.get<types.APIResponse<types.PublicSurvey>>(`/public/surveys/${enc(token)}`)).data.data;
  }

  async submitPublicSurvey(token: string, answer: types.PublicSurveyAnswer): Promise<{ status: 'ANSWERED' }> {
    return (await this.http.post<types.APIResponse<{ status: 'ANSWERED' }>>(`/public/surveys/${enc(token)}`, answer)).data.data;
  }
}
